import { useEffect } from 'react'

function usePasteHandler(callback) {
  useEffect(() => {
    const pasteHandler = (e) => {
      const file = e.clipboardData?.files?.[0]

      if (file) {
        callback(file)
      }
    }

    document.addEventListener('paste', pasteHandler)

    return () => document.removeEventListener('paste', pasteHandler)

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
}

export default usePasteHandler
